import React from 'react';

import { FloatingZigzinBanner } from '../components/FloatingZigzinBanner';
import { useFloatingZigzinBannerService } from '../services/useFloatingZigzinBannerService';

interface FloatingZigzinBannerContainerProps {
  is_app: boolean;
  is_logged_in: boolean;
}
export const FloatingZigzinBannerContainer: React.FC<React.PropsWithChildren<FloatingZigzinBannerContainerProps>> = ({
  is_app,
  is_logged_in,
}) => {
  const {
    showBottomZigzinBanner,
    discount_banner_info,
    handleLinkButton,
    handleCloseButton,
    handleImpressionZigzinBanner,
  } = useFloatingZigzinBannerService({ is_app, is_logged_in });

  if (!showBottomZigzinBanner) {
    return null;
  }
  return (
    <FloatingZigzinBanner
      text={discount_banner_info?.text ?? ''}
      icon_type={discount_banner_info?.icon_type ?? null}
      handleLinkButton={handleLinkButton}
      handleCloseButton={handleCloseButton}
      onImpression={handleImpressionZigzinBanner}
    />
  );
};
